import type { NotifyPort } from '@/features/messages/domain/notify'
import type { MemberPort, TeamMember } from '../domain/member'

type UpsertInput = Partial<Omit<TeamMember, 'id' | 'emergencyContacts'>> &
	Required<Pick<TeamMember, 'fullName' | 'email' | 'employmentType' | 'status'>>

const upsertMember = async (
	port: MemberPort,
	data: UpsertInput & { id?: string },
	notify: NotifyPort,
): Promise<TeamMember> => {
	try {
		if (data.id) {
			const { id, ...fields } = data
			return await port.update(id, fields)
		}
		const { id: _id, ...fields } = data
		return await port.create(fields as Omit<TeamMember, 'id' | 'emergencyContacts'>)
	} catch {
		notify.error('hr.memberSaveFailed')
		throw new Error('Failed to save team member.')
	}
}

export { upsertMember }
export type { UpsertInput }
